import { forwardRef } from 'react';
import { Em as RadixEm } from '@radix-ui/themes';
import type { RadixEmProps } from '@/types/radix-ui';

/**
 * Em component - wrapper around Radix UI Em
 * Provides semantic emphasis for text
 */
export type EmProps = RadixEmProps;

const Em = forwardRef<HTMLElement, EmProps>((props, ref) => {
  return <RadixEm ref={ref} {...props} />;
});

Em.displayName = 'Em';

export { Em };
